import { autoPliotTypes } from './autopilot-types';
import { states } from './usa-states';
export const tools = [
  {
    type: 'function',
    function: {
      name: 'get_listings',
      description: 'Retrieves property listings based on specified criteria.',
      parameters: {
        type: 'object',
        properties: {
          location: {
            type: 'string',
            description: 'The location for the listing search.',
          },
          listingType: {
            type: 'string',
            enum: ['Sale', 'Lease'],
            description: 'Type of listing to search for.',
          },
          year: {
            type: 'integer',
            description: 'Year of car manufacture or listing.',
          },
          trim: {
            type: 'string',
            description: 'The trim level of the Tesla model.',
          },
          keywords: {
            type: 'string',
            description: 'General keywords to search for in listings.',
          },
          condition: {
            type: 'string',
            enum: ['Excellent', 'Good', 'Fair', 'VeryGood'],
            description: 'Condition of the vehicle.',
          },
          model: {
            type: 'string',
            enum: [
              'Model S',
              'Model 3',
              'Model X',
              'Model Y',
              'CYBERTRUCK',
              'Roadster',
            ],
            description: 'The type of Tesla model.',
          },
          autopilot: {
            type: 'string',
            enum: [
              'Autopilot 1',
              'Autopilot 2 (Enhanced)',
              'Base Autopilot',
              'Full Self-Driving',
              'HW-2.0',
              'HW-2.5',
              'HW-3.0',
              'Pre-Autopilot.',
            ],
            description: 'The autopilot feature of the Tesla vehicle.',
          },
        },
      },
    },
  },
  {
    type: 'function',
    function: {
      name: 'create_listing',
      description:
        'Create a Tesla vehicle listing for sale in the inventory, validating all required fields including vehicle details. If the user has not provided a value for a field, set it to null. Do not guess or invent any value. For example, if the user does not provide a city, set it to null.',
      parameters: {
        type: 'object',
        properties: {
          type: {
            type: ['string', 'null'],
            enum: ['ForSale', 'ForLease'],
            description: "Type of listing. Usually 'ForSale'.",
            default: 'ForSale',
          },
          price: {
            type: ['integer', 'null'],
            description: 'Price of the vehicle in USD.',
            minimum: 0,
          },
          city: {
            type: ['string', 'null'],
            description:
              'City where the vehicle is located. If unknown or not provided, must be null — do not guess.',
          },
          state: {
            type: ['string', 'null'],
            enum: states,
            description: 'State where the provided city is in',
          },
          vin: {
            type: ['string', 'null'],
            minLength: 17,
            maxLength: 17,
            description: 'Vehicle Identification Number (VIN) of the Tesla.',
          },
          condition: {
            type: ['string', 'null'],
            enum: ['Excellent', 'Good', 'Fair', 'VeryGood'],
            description:
              'Condition of the vehicle. Must only be set if the user explicitly provides it; otherwise, null.',
          },
          mileage: {
            type: ['number', 'null'],
            maximum: 999999,
            description: 'Mileage of the vehicle in miles.',
          },
          make: {
            type: 'string',
            default: 'Tesla',
            description: 'Make of the vehicle.',
          },
          model: {
            type: ['string', 'null'],
            enum: [
              'Model S',
              'Model 3',
              'Model X',
              'Model Y',
              'CYBERTRUCK',
              'Roadster',
            ],
            description: 'Model of the Tesla vehicle. Must only be set if the user explicitly provides it; otherwise, null.',
          },
          trim: {
            type: ['string', 'null'],
            description: 'Trim level of the Tesla vehicle., required: true',
          },
          year: {
            type: ['integer', 'null'],
            minimum: 2008,
            description: 'Year of manufacture of the vehicle.',
          },
          leaseMonthsRemaining: {
            type: ['integer', 'null'],
            minimum: 0,
            description:
              "Number of months remaining on the lease, if applicable. required if type is 'ForLease'",
          },
          colour: {
            type: ['string', 'null'],
            description: 'Colour of the vehicle.',
          },
          autopilot: {
            type: ['boolean', 'null'],
            description: 'Does the vehicle have Autopilot?',
          },
          cleanHistory: {
            type: ['boolean', 'null'],
            description: 'Does the vehicle have a clean history report?',
          },
          warranty: {
            type: ['boolean', 'null'],
            description: 'Is the vehicle still under warranty?',
          },
          modifications: {
            type: ['boolean', 'null'],
            description: 'Has the vehicle been modified?',
          },
          title: {
            type: ['boolean', 'null'],
            description: 'Does the vehicle have a clear title?',
          },
          fsd: {
            type: ['boolean', 'null'],
            description: 'Does the vehicle have Full Self-Driving?',
          },
          autopilotType: {
            type: ['string', 'null'],
            enum: [...autoPliotTypes, null], // explicitly allow null in enum
            description:
              'The autopilot type of the Tesla vehicle. Only set if the user has explicitly provided it. If not provided, set to null. Do not guess.',
          },
        },
        required: [
          'type',
          'price',
          'vin',
          'condition',
          'mileage',
          'model',
          'year',
          'colour',
          'autopilot',
          'cleanHistory',
          'warranty',
          'modifications',
          'title',
          'fsd',
          'autopilotType',
          'leaseMonthsRemaining',
        ],
        strict: true,
        additionalProperties: false,
      },
    },
  },
];
